import React from 'react';
import { Typography } from 'antd';

const ErrorBlock = ({ message }) => {
  if (!message) return null;

  return <Typography.Text type="danger">{message}</Typography.Text>;
};

export default ErrorBlock;
